export enum Size {
  EXTRA_LARGE,
  LARGE,
  MEDIUM,
  SMALL,
  EXTRA_SMALL
}
